export default __webpack_public_path__ + "static/media/Bennet1.6c81d265.mp3";